import { useNavigate } from "react-router-dom";

import { Button, Logo } from "@/atoms";
import { routes, strings } from "@/constants";
import { LogoSizeEnum } from "@/enums";

export const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <div
            className="
                flex
                min-h-screen
                flex-col
                bg-background
            "
        >
            <header className="p-4 sm:p-6">
                <Logo size={LogoSizeEnum.MD} />
            </header>
            <main
                className="
                    flex
                    flex-1
                    items-center
                    justify-center
                    px-4
                "
            >
                <div className="max-w-md text-center">
                    <h1
                        className="
                            mb-4
                            text-7xl
                            font-bold
                            text-primary
                            sm:text-9xl
                        "
                    >
                        {strings.notFound.title}
                    </h1>
                    <h2
                        className="
                            text-gradient
                            mb-4
                            text-2xl
                            font-bold
                            sm:text-3xl
                        "
                    >
                        {strings.notFound.subtitle}
                    </h2>
                    <p className="mb-8 text-text-secondary">{strings.notFound.description}</p>
                    <Button onClick={() => navigate(routes.benchmark)}>{strings.notFound.backToHome}</Button>
                </div>
            </main>
        </div>
    );
};
